<template>
  <Dialog ref="dialog" width="50%" icon="fas fa-box" @confirm="verify" :show-confirm="countSocToLoad < 1"
    title="Cargar LPN packages">
    <div v-if="countSocToLoad < 1">
      <el-input type="textarea" id="container" :rows="3" placeholder="700000000000167153, 700000000000167154 ..."
        v-model="textareaLpns">
      </el-input>
    </div>
    <div v-else class="progress">
      <p class="indicator">
        <span>total a verificar: </span>{{ countSocToLoad }}
      </p>
      <el-progress :color="color" :text-inside="true" :stroke-width="20" :percentage="loadPercentage" />
      <p class="indicators">
        <i :class="loadIcon" /> {{ msgLoad }}
        <span class="in-load">
          verificadas: <span class="verified">{{ countVerified }}</span> /
          no encontradas: <span class="not-found">{{ countNotFound }}</span> /
        </span>
      </p>
    </div>
  </Dialog>
</template>

<script>
import Dialog from '../../base/Dialog.vue';
import { apiRequest } from '../../../../backend/vue-axios/axios';

export default {
  name: 'LpnAdd',
  components: {
    Dialog,
  },
  props: {
    value: {
      type: Array,
      default() {
        return [];
      },
    },
    sectors: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      msgLoad: 'Procesando . . .',
      withSplits: false,
      countSocToLoad: 0,
      countCurrentSocLoad: 0,
      countVerified: 0,
      countNotFound: 0,
      countSplits: 0,
      maxPerBatch: 500,
      list: this.value,
      textareaLpns: '',
      color: '#AAD500',
    };
  },
  watch: {
    list() {
      this.$emit('input', this.list);
    },
    value() {
      this.list = this.value;
    },
    countCurrentSocLoad(value) {
      this.msgLoad = `Solicitando verificación: ${value} de ${this.countSocToLoad}`;
      if (value === this.countSocToLoad) this.$refs.dialog.loading(false);
      if (this.loadPercentage === 100) this.msgLoad = 'Verificación finalizada';
    },
  },
  filters: {
    len(data) {
      return data.length;
    },
  },
  methods: {
    open() {
      this.msgLoad = 'Procesando . . .';
      this.countSocToLoad = 0;
      this.countCurrentSocLoad = 0;
      this.countVerified = 0;
      this.countNotFound = 0;
      this.countSplits = 0;
      this.$refs.dialog.visible(true);
    },
    verify() {
      const newLpns = this.clearInput(this.textareaLpns)
        .filter(ns => !this.list.map(s => s.lpn).includes(ns));

      this.list = newLpns
        .map(s => ({
          lpn: s, suborder: 0, verified: false, sectors: [],
        }))
        .concat(this.list);
      this.loadOnlyLpns(newLpns);
      this.textareaLpns = '';

    },
    clearInput(textInput) {
      return [...new Set(textInput.trim()
        .split(/\s*[,\n\r][\s\n\r]*/gimu)
        // .filter(s => s.match(/^[0-9]{6,20}$/gim))
        .map(s => s))];
    },
    loadOnlyLpns(newLpns) {
      if (newLpns.length > 0) {
        const partialNewLpns = [];
        this.countSocToLoad = newLpns.length;
        while (newLpns.length) partialNewLpns.push(newLpns.splice(0, this.maxPerBatch));
        this.loadBatch(partialNewLpns, 5000);
      } else {
        this.$refs.dialog.loading(false);
        this.$notify({
          type: 'warning',
          title: 'Error al cargas los lpns',
          message: 'No son válidas o están repetidas',
        });
      }
    },
    loadBatch(batch, delay) {
      const newBatch = batch.splice(0, 2);
      newBatch.forEach(async (request) => {
        await this.verifyPartial(request).then(async (Lpns) => {
          await this.loadPercent(Lpns);
        });
      });
      if (batch.length > 0) {
        setTimeout(() => { this.loadBatch(batch, delay - (delay / 10)); }, delay);
      }
    },
    loadPercent(Lpns) {
      const totalNotFound = Lpns.filter(s => this.notFound(s)).length;
      this.countVerified += Lpns.length - totalNotFound;
      this.countNotFound += totalNotFound;
      this.countSplits += Lpns.filter(s => s.splits).length;
      const progress = [];
      while (Lpns.length) progress.push(Lpns.splice(0, 50).length);
      for (let i = 0; i < progress.length; i += 1) {
        setTimeout(() => { this.countCurrentSocLoad += progress[i]; }, 25);
      }
    },
    verifyPartial(partialNewLpns) {
      return new Promise((resolve) => {
        apiRequest({
          module: 'planning',
          service: 'verify_lpn',
          params: {
            lpn_list: partialNewLpns,
            with_splits: false,
          },
        }).then((response) => {
          resolve(response.data);

          const listLpnDeleted = [];


          response.data.forEach((val) => {

            if (listLpnDeleted.includes(val.lpn) === false) {
              listLpnDeleted.push(val.lpn);
              const element = this.list.find(s => s.lpn === val.lpn);
              const index = this.list.indexOf(element);
              this.list.splice(index, 1);
            }

            this.list.push(
              {
                lpn: val.lpn,
                suborder: val.suborder,
                current_do: val.current_do,
                dp_id: val.dp_id,
                geostate: val.geostate,
                locality_id: val.locality_id,
                locality: val.locality,
                price: val.price,
                volume: val.volume,
                lat: val.lat,
                lng: val.lng,
                requested_at: val.requested_at,
                last_state: val.last_state,
                last_state_name: val.last_state_name,
                package_type_id: val.package_type_id,
                package_type_name: val.package_type_name,
                document_type_name: val.document_type_name,
                verified: true,
                sectors: this.sectors
                  .filter((sector) => { return (sector.packageTypes.map(l => l.id).includes(val.package_type_id)
                      || (sector.packageTypes.length > 0 && val.package_type_name === 'NF'))
                      && sector.localities.map(l => l.id).includes(val.locality_id)
                      && !(val.splits || [5, 6].includes(val.last_state));
                  }),
              },
            );
          });
          this.$refs.dialog.loading(false);
        }).catch(() => {
          this.countNotFound += partialNewLpns.length;
          this.countCurrentSocLoad += partialNewLpns.length;
          this.list = this.list.filter(s => !partialNewLpns.includes(s.suborder));
          this.$notify({
            type: 'error',
            title: 'Error al cargas los lpn',
            message: 'Vuelva a intentarlo más tardes',
          });
        });
      });
    },
    notFound(soc) {
      return soc.current_do === -1;
    },
  },
  computed: {
    loadPercentage() {

      return 100;
    },
    colorSwitch() {
      return this.withSplits ? '' : 'disable-color';
    },
    loadIcon() {
      return this.loadPercentage === 100 ? 'el-icon-folder-checked' : 'el-icon-loading';
    },
  },
};
</script>

<style lang="scss" scoped>
.switch-with-splits {
  height: 20px;
  margin: 10px 0;

  span {
    margin: 0 8px;
    line-height: 1.4;
  }

  span,
  .el-switch {
    float: right;
  }

  .disable-color {
    color: $fb-grey-light-92;
  }
}

.loading {
  text-align: center;

  .el-icon-loading {
    font-size: 32px;
    color: $fb-green;
  }
}

.progress {
  margin: 14px;

  .indicators {
    height: 18px;
    font-size: 13px;
    margin: 4px 2px;
    font-weight: 300;
    text-transform: lowercase;

    i {
      color: $fb-green;
      font-weight: 900;
      margin-right: 3px;
    }

    .in-load {
      float: right;

      .split {
        color: $fb-amber;
      }

      .verified {
        color: $fb-blue;
      }

      .not-found {
        color: $fb-red;
      }

      .split,
      .verified,
      .not-found {
        font-weight: 600;
      }
    }
  }

  .indicator {
    font-size: 13px;
    font-weight: 600;
    margin: 0 0 4px 3px;

    span {
      font-weight: 300;
    }

    text-transform: lowercase;
  }
}
</style>
